/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Paypoint/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Paypoint({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/AddAction/Content/Content/Payabli/Paypoints/CustomOptions/Paypoint",
  onPaypointClick
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let addProviderPayabliPaypointItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'add_provider_payabli_paypoint_item',
path: 'isFirst',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onPaypointClick,
  isHovered
  
})
let addProviderPayabliPaypointIdValueData = fromData.useDataValue({ viewPath,
context: 'add_provider_payabli_paypoint',
path: 'id',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let constantData = 'Paypoint:'
let addProviderPayabliPaypointNameValueData = fromData.useDataValue({ viewPath,
context: 'add_provider_payabli_paypoint',
path: 'name',
})
let aggregateData = fromAggregate.join(constantData, addProviderPayabliPaypointNameValueData)
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let constantData1 = 'Parent Organization:'
let addProviderPayabliPaypointParentOrgNameValueData = fromData.useDataValue({ viewPath,
context: 'add_provider_payabli_paypoint',
path: 'parentOrgName',
})
let aggregateData1 = fromAggregate.join(constantData1, addProviderPayabliPaypointParentOrgNameValueData)
let addProviderPayabliPaypointUsedByValueData = fromData.useDataFormat({ viewPath,
context: 'add_provider_payabli_paypoint',
path: 'usedBy',
format: fromHelpers.getUsedByText,
})
  return (<React.Fragment
>
<button
  data-testid="Paypoint.Horizontal"
  data-view-path={viewPath}
 onPaypointClick={onPaypointClick}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--pl-1-1HJU0D': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-2-1HJU0D': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-3-1HJU0D': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-4-1HJU0D': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-6-1HJU0D': isHovered ? dtColorsNeutral100 : dtColorsWhite,'--mt-5-1HJU0D': addProviderPayabliPaypointItemIsFirstValueData ? "0px" : typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Paypoint.Vertical"
  data-view-path={viewPath}
 style={{'--g-7-1HJU0D': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="add_provider_payabli_paypoint.id"
 text={addProviderPayabliPaypointIdValueData}
 color={dtColorsNeutral900}
 weight="semibold"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'Paypoint:'"
 data="add_provider_payabli_paypoint.name"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
 color={dtColorsNeutral400}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'Parent Organization:'"
 data="add_provider_payabli_paypoint.parentOrgName"
 aggregate="/Data/aggregate.js join"
 text={aggregateData1}
 color={dtColorsNeutral400}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft="auto"
 data="add_provider_payabli_paypoint.usedBy"
 format="helpers.js getUsedByText"
 text={addProviderPayabliPaypointUsedByValueData}
 color={dtColorsNeutral400}
 weight="semibold"
/>
</button>
{children}
</React.Fragment>)
}